/**
 * @fileoverview gRPC-Web generated client stub for cloud
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var billing_pb = require('./billing_pb.js')
const proto = {};
proto.cloud = require('./service_billing_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceBillingClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceBillingPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.CloudPricingRequest,
 *   !proto.cloud.CloudPricingResponse>}
 */
const methodDescriptor_ServiceBilling_RetrieveCloudPricing = new grpc.web.MethodDescriptor(
  '/cloud.ServiceBilling/RetrieveCloudPricing',
  grpc.web.MethodType.UNARY,
  proto.cloud.CloudPricingRequest,
  proto.cloud.CloudPricingResponse,
  /**
   * @param {!proto.cloud.CloudPricingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.CloudPricingResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.CloudPricingRequest,
 *   !proto.cloud.CloudPricingResponse>}
 */
const methodInfo_ServiceBilling_RetrieveCloudPricing = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.CloudPricingResponse,
  /**
   * @param {!proto.cloud.CloudPricingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.CloudPricingResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.CloudPricingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.CloudPricingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.CloudPricingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceBillingClient.prototype.retrieveCloudPricing =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceBilling/RetrieveCloudPricing',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_RetrieveCloudPricing,
      callback);
};


/**
 * @param {!proto.cloud.CloudPricingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.CloudPricingResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceBillingPromiseClient.prototype.retrieveCloudPricing =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceBilling/RetrieveCloudPricing',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_RetrieveCloudPricing);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.AddPaymentMethodRequest,
 *   !proto.cloud.AddPaymentMethodResponse>}
 */
const methodDescriptor_ServiceBilling_AddPaymentMethod = new grpc.web.MethodDescriptor(
  '/cloud.ServiceBilling/AddPaymentMethod',
  grpc.web.MethodType.UNARY,
  proto.cloud.AddPaymentMethodRequest,
  proto.cloud.AddPaymentMethodResponse,
  /**
   * @param {!proto.cloud.AddPaymentMethodRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.AddPaymentMethodResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.AddPaymentMethodRequest,
 *   !proto.cloud.AddPaymentMethodResponse>}
 */
const methodInfo_ServiceBilling_AddPaymentMethod = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.AddPaymentMethodResponse,
  /**
   * @param {!proto.cloud.AddPaymentMethodRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.AddPaymentMethodResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.AddPaymentMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.AddPaymentMethodResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.AddPaymentMethodResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceBillingClient.prototype.addPaymentMethod =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceBilling/AddPaymentMethod',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_AddPaymentMethod,
      callback);
};


/**
 * @param {!proto.cloud.AddPaymentMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.AddPaymentMethodResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceBillingPromiseClient.prototype.addPaymentMethod =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceBilling/AddPaymentMethod',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_AddPaymentMethod);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.ClientSecretRequest,
 *   !proto.cloud.ClientSecretResponse>}
 */
const methodDescriptor_ServiceBilling_RetrieveClientSecret = new grpc.web.MethodDescriptor(
  '/cloud.ServiceBilling/RetrieveClientSecret',
  grpc.web.MethodType.UNARY,
  proto.cloud.ClientSecretRequest,
  proto.cloud.ClientSecretResponse,
  /**
   * @param {!proto.cloud.ClientSecretRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.ClientSecretResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.ClientSecretRequest,
 *   !proto.cloud.ClientSecretResponse>}
 */
const methodInfo_ServiceBilling_RetrieveClientSecret = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.ClientSecretResponse,
  /**
   * @param {!proto.cloud.ClientSecretRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.ClientSecretResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.ClientSecretRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.ClientSecretResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.ClientSecretResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceBillingClient.prototype.retrieveClientSecret =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceBilling/RetrieveClientSecret',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_RetrieveClientSecret,
      callback);
};


/**
 * @param {!proto.cloud.ClientSecretRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.ClientSecretResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceBillingPromiseClient.prototype.retrieveClientSecret =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceBilling/RetrieveClientSecret',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_RetrieveClientSecret);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.SavedPaymentRequest,
 *   !proto.cloud.SavedPaymentResponse>}
 */
const methodDescriptor_ServiceBilling_RetrieveSavedPaymentMethods = new grpc.web.MethodDescriptor(
  '/cloud.ServiceBilling/RetrieveSavedPaymentMethods',
  grpc.web.MethodType.UNARY,
  proto.cloud.SavedPaymentRequest,
  proto.cloud.SavedPaymentResponse,
  /**
   * @param {!proto.cloud.SavedPaymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.SavedPaymentResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.SavedPaymentRequest,
 *   !proto.cloud.SavedPaymentResponse>}
 */
const methodInfo_ServiceBilling_RetrieveSavedPaymentMethods = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.SavedPaymentResponse,
  /**
   * @param {!proto.cloud.SavedPaymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.SavedPaymentResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.SavedPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.SavedPaymentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.SavedPaymentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceBillingClient.prototype.retrieveSavedPaymentMethods =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceBilling/RetrieveSavedPaymentMethods',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_RetrieveSavedPaymentMethods,
      callback);
};


/**
 * @param {!proto.cloud.SavedPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.SavedPaymentResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceBillingPromiseClient.prototype.retrieveSavedPaymentMethods =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceBilling/RetrieveSavedPaymentMethods',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_RetrieveSavedPaymentMethods);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.DeletePaymentRequest,
 *   !proto.cloud.DeletePaymentResponse>}
 */
const methodDescriptor_ServiceBilling_DeletePayment = new grpc.web.MethodDescriptor(
  '/cloud.ServiceBilling/DeletePayment',
  grpc.web.MethodType.UNARY,
  proto.cloud.DeletePaymentRequest,
  proto.cloud.DeletePaymentResponse,
  /**
   * @param {!proto.cloud.DeletePaymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.DeletePaymentResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.DeletePaymentRequest,
 *   !proto.cloud.DeletePaymentResponse>}
 */
const methodInfo_ServiceBilling_DeletePayment = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.DeletePaymentResponse,
  /**
   * @param {!proto.cloud.DeletePaymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.DeletePaymentResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.DeletePaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.DeletePaymentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.DeletePaymentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceBillingClient.prototype.deletePayment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceBilling/DeletePayment',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_DeletePayment,
      callback);
};


/**
 * @param {!proto.cloud.DeletePaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.DeletePaymentResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceBillingPromiseClient.prototype.deletePayment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceBilling/DeletePayment',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_DeletePayment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.SetDefaultPaymentMethodRequest,
 *   !proto.cloud.SetDefaultPaymentMethodResponse>}
 */
const methodDescriptor_ServiceBilling_SetDefaultPaymentMethod = new grpc.web.MethodDescriptor(
  '/cloud.ServiceBilling/SetDefaultPaymentMethod',
  grpc.web.MethodType.UNARY,
  proto.cloud.SetDefaultPaymentMethodRequest,
  proto.cloud.SetDefaultPaymentMethodResponse,
  /**
   * @param {!proto.cloud.SetDefaultPaymentMethodRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.SetDefaultPaymentMethodResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.SetDefaultPaymentMethodRequest,
 *   !proto.cloud.SetDefaultPaymentMethodResponse>}
 */
const methodInfo_ServiceBilling_SetDefaultPaymentMethod = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.SetDefaultPaymentMethodResponse,
  /**
   * @param {!proto.cloud.SetDefaultPaymentMethodRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.SetDefaultPaymentMethodResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.SetDefaultPaymentMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.SetDefaultPaymentMethodResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.SetDefaultPaymentMethodResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceBillingClient.prototype.setDefaultPaymentMethod =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceBilling/SetDefaultPaymentMethod',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_SetDefaultPaymentMethod,
      callback);
};


/**
 * @param {!proto.cloud.SetDefaultPaymentMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.SetDefaultPaymentMethodResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceBillingPromiseClient.prototype.setDefaultPaymentMethod =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceBilling/SetDefaultPaymentMethod',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_SetDefaultPaymentMethod);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.SubscriptionCreationRequest,
 *   !proto.cloud.SubscriptionCreationResponse>}
 */
const methodDescriptor_ServiceBilling_CreateSubscription = new grpc.web.MethodDescriptor(
  '/cloud.ServiceBilling/CreateSubscription',
  grpc.web.MethodType.UNARY,
  proto.cloud.SubscriptionCreationRequest,
  proto.cloud.SubscriptionCreationResponse,
  /**
   * @param {!proto.cloud.SubscriptionCreationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.SubscriptionCreationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.SubscriptionCreationRequest,
 *   !proto.cloud.SubscriptionCreationResponse>}
 */
const methodInfo_ServiceBilling_CreateSubscription = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.SubscriptionCreationResponse,
  /**
   * @param {!proto.cloud.SubscriptionCreationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.SubscriptionCreationResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.SubscriptionCreationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.SubscriptionCreationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.SubscriptionCreationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceBillingClient.prototype.createSubscription =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceBilling/CreateSubscription',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_CreateSubscription,
      callback);
};


/**
 * @param {!proto.cloud.SubscriptionCreationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.SubscriptionCreationResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceBillingPromiseClient.prototype.createSubscription =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceBilling/CreateSubscription',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_CreateSubscription);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.SubscriptionCancelRequest,
 *   !proto.cloud.SubscriptionCancelResponse>}
 */
const methodDescriptor_ServiceBilling_CancelSubscription = new grpc.web.MethodDescriptor(
  '/cloud.ServiceBilling/CancelSubscription',
  grpc.web.MethodType.UNARY,
  proto.cloud.SubscriptionCancelRequest,
  proto.cloud.SubscriptionCancelResponse,
  /**
   * @param {!proto.cloud.SubscriptionCancelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.SubscriptionCancelResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.SubscriptionCancelRequest,
 *   !proto.cloud.SubscriptionCancelResponse>}
 */
const methodInfo_ServiceBilling_CancelSubscription = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.SubscriptionCancelResponse,
  /**
   * @param {!proto.cloud.SubscriptionCancelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.SubscriptionCancelResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.SubscriptionCancelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.SubscriptionCancelResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.SubscriptionCancelResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceBillingClient.prototype.cancelSubscription =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceBilling/CancelSubscription',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_CancelSubscription,
      callback);
};


/**
 * @param {!proto.cloud.SubscriptionCancelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.SubscriptionCancelResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceBillingPromiseClient.prototype.cancelSubscription =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceBilling/CancelSubscription',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_CancelSubscription);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.SubscriptionListRequest,
 *   !proto.cloud.SubscriptionListResponse>}
 */
const methodDescriptor_ServiceBilling_ListSubscriptions = new grpc.web.MethodDescriptor(
  '/cloud.ServiceBilling/ListSubscriptions',
  grpc.web.MethodType.UNARY,
  proto.cloud.SubscriptionListRequest,
  proto.cloud.SubscriptionListResponse,
  /**
   * @param {!proto.cloud.SubscriptionListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.SubscriptionListResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.SubscriptionListRequest,
 *   !proto.cloud.SubscriptionListResponse>}
 */
const methodInfo_ServiceBilling_ListSubscriptions = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.SubscriptionListResponse,
  /**
   * @param {!proto.cloud.SubscriptionListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.SubscriptionListResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.SubscriptionListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.SubscriptionListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.SubscriptionListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceBillingClient.prototype.listSubscriptions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceBilling/ListSubscriptions',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_ListSubscriptions,
      callback);
};


/**
 * @param {!proto.cloud.SubscriptionListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.SubscriptionListResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceBillingPromiseClient.prototype.listSubscriptions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceBilling/ListSubscriptions',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_ListSubscriptions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.InvoiceListRequest,
 *   !proto.cloud.InvoiceListResponse>}
 */
const methodDescriptor_ServiceBilling_ListInvoices = new grpc.web.MethodDescriptor(
  '/cloud.ServiceBilling/ListInvoices',
  grpc.web.MethodType.UNARY,
  proto.cloud.InvoiceListRequest,
  proto.cloud.InvoiceListResponse,
  /**
   * @param {!proto.cloud.InvoiceListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.InvoiceListResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.InvoiceListRequest,
 *   !proto.cloud.InvoiceListResponse>}
 */
const methodInfo_ServiceBilling_ListInvoices = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.InvoiceListResponse,
  /**
   * @param {!proto.cloud.InvoiceListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.InvoiceListResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.InvoiceListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.InvoiceListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.InvoiceListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceBillingClient.prototype.listInvoices =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceBilling/ListInvoices',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_ListInvoices,
      callback);
};


/**
 * @param {!proto.cloud.InvoiceListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.InvoiceListResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceBillingPromiseClient.prototype.listInvoices =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceBilling/ListInvoices',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_ListInvoices);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.SubscriptionUncancelRequest,
 *   !proto.cloud.SubscriptionUncancelResponse>}
 */
const methodDescriptor_ServiceBilling_UncancelSubscription = new grpc.web.MethodDescriptor(
  '/cloud.ServiceBilling/UncancelSubscription',
  grpc.web.MethodType.UNARY,
  proto.cloud.SubscriptionUncancelRequest,
  proto.cloud.SubscriptionUncancelResponse,
  /**
   * @param {!proto.cloud.SubscriptionUncancelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.SubscriptionUncancelResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.SubscriptionUncancelRequest,
 *   !proto.cloud.SubscriptionUncancelResponse>}
 */
const methodInfo_ServiceBilling_UncancelSubscription = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.SubscriptionUncancelResponse,
  /**
   * @param {!proto.cloud.SubscriptionUncancelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.SubscriptionUncancelResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.SubscriptionUncancelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.SubscriptionUncancelResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.SubscriptionUncancelResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceBillingClient.prototype.uncancelSubscription =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceBilling/UncancelSubscription',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_UncancelSubscription,
      callback);
};


/**
 * @param {!proto.cloud.SubscriptionUncancelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.SubscriptionUncancelResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceBillingPromiseClient.prototype.uncancelSubscription =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceBilling/UncancelSubscription',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_UncancelSubscription);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.SubscriptionModificationRequest,
 *   !proto.cloud.SubscriptionModificationResponse>}
 */
const methodDescriptor_ServiceBilling_ModifySubscription = new grpc.web.MethodDescriptor(
  '/cloud.ServiceBilling/ModifySubscription',
  grpc.web.MethodType.UNARY,
  proto.cloud.SubscriptionModificationRequest,
  proto.cloud.SubscriptionModificationResponse,
  /**
   * @param {!proto.cloud.SubscriptionModificationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.SubscriptionModificationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.SubscriptionModificationRequest,
 *   !proto.cloud.SubscriptionModificationResponse>}
 */
const methodInfo_ServiceBilling_ModifySubscription = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.SubscriptionModificationResponse,
  /**
   * @param {!proto.cloud.SubscriptionModificationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.SubscriptionModificationResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.SubscriptionModificationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.SubscriptionModificationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.SubscriptionModificationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceBillingClient.prototype.modifySubscription =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceBilling/ModifySubscription',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_ModifySubscription,
      callback);
};


/**
 * @param {!proto.cloud.SubscriptionModificationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.SubscriptionModificationResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceBillingPromiseClient.prototype.modifySubscription =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceBilling/ModifySubscription',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_ModifySubscription);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.SubscriptionPreviewChangeRequest,
 *   !proto.cloud.SubscriptionPreviewChangeResponse>}
 */
const methodDescriptor_ServiceBilling_PreviewSubscriptionChange = new grpc.web.MethodDescriptor(
  '/cloud.ServiceBilling/PreviewSubscriptionChange',
  grpc.web.MethodType.UNARY,
  proto.cloud.SubscriptionPreviewChangeRequest,
  proto.cloud.SubscriptionPreviewChangeResponse,
  /**
   * @param {!proto.cloud.SubscriptionPreviewChangeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.SubscriptionPreviewChangeResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.SubscriptionPreviewChangeRequest,
 *   !proto.cloud.SubscriptionPreviewChangeResponse>}
 */
const methodInfo_ServiceBilling_PreviewSubscriptionChange = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.SubscriptionPreviewChangeResponse,
  /**
   * @param {!proto.cloud.SubscriptionPreviewChangeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.SubscriptionPreviewChangeResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.SubscriptionPreviewChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.SubscriptionPreviewChangeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.SubscriptionPreviewChangeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceBillingClient.prototype.previewSubscriptionChange =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceBilling/PreviewSubscriptionChange',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_PreviewSubscriptionChange,
      callback);
};


/**
 * @param {!proto.cloud.SubscriptionPreviewChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.SubscriptionPreviewChangeResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceBillingPromiseClient.prototype.previewSubscriptionChange =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceBilling/PreviewSubscriptionChange',
      request,
      metadata || {},
      methodDescriptor_ServiceBilling_PreviewSubscriptionChange);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceInternalBillingClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceInternalBillingPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


module.exports = proto.cloud;

